import React from "react";
import { Button, FormGroup } from "react-bootstrap";
import { useFormContext } from "./Form";
import { observer } from "mobx-react-lite";
import { isObservableObject, values } from "mobx";
import { useTranslation } from "./hooks/useTranslation";
import { useButtonClasses } from "./Button/Button.styles";
import { classNames } from "./utils/classNames";
import { Tooltip } from "./Tooltip";
import { v4 as uuid } from "uuid";
export const hasErrors = (error) => {
    if (isObservableObject(error)) {
        return values(error).some(hasErrors);
    }
    return error === "error";
};
const BUTTON_TYPE = "primary";
export const Submit = observer(({ label, inline = false, disabled = false, disabledTooltipContent, isDirty, id, dataId, dataTestId, className, dataHook = "submit-button", "data-sentry-label": sentryLabel, }) => {
    const { errors, formDisabled } = useFormContext();
    const t = useTranslation();
    if (label === undefined) {
        label = t("Submit");
        sentryLabel = "Submit";
    }
    const classes = useButtonClasses(BUTTON_TYPE);
    const disabledFromErrors = hasErrors(errors);
    const buttonDisabled = disabled || disabledFromErrors || formDisabled || isDirty === false;
    const button = (React.createElement(Button, { type: "submit", disabled: buttonDisabled, bsStyle: BUTTON_TYPE, id: id, "data-testid": dataTestId, "data-id": dataId, className: classNames(classes.button, className ?? ""), "data-hook": dataHook, "data-sentry-label": sentryLabel }, label));
    const buttonWithTooltip = !buttonDisabled || !disabledTooltipContent ? (button) : (React.createElement(Tooltip, { content: disabledTooltipContent, tooltipId: `button-${id || uuid()}-tooltip`, iconShown: false }, button));
    return !inline ? (React.createElement(FormGroup, null, buttonWithTooltip)) : (buttonWithTooltip);
});
